var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gnip-tabs-pane"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$parent.activeName == _vm.name),expression:"$parent.activeName == name"}],staticClass:"tab-pane-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }